var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLinkApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 72,
    viewBox: "0 0 239 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7779",
    "data-name": "Group 7779",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1347",
    "data-name": "Rectangle 1347",
    transform: "translate(0 0)",
    stroke: "#a6a6a6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 72,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 238,
    height: 71,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7780",
    "data-name": "Group 7780",
    transform: "translate(31.585 13.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    transform: "translate(0 0.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    d: "M26.261,18.552A8.753,8.753,0,0,1,30.443,11.2,9,9,0,0,0,23.36,7.386c-2.98-.312-5.869,1.778-7.388,1.778-1.548,0-3.886-1.747-6.4-1.7A9.436,9.436,0,0,0,1.63,12.3C-1.8,18.222.758,26.93,4.046,31.72c1.645,2.346,3.567,4.966,6.083,4.873,2.462-.1,3.381-1.565,6.352-1.565,2.944,0,3.806,1.565,6.373,1.506,2.641-.043,4.306-2.356,5.893-4.724a19.377,19.377,0,0,0,2.695-5.473,8.462,8.462,0,0,1-5.181-7.785Z",
    transform: "translate(0 1.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    d: "M18.143,6.177A8.607,8.607,0,0,0,20.121,0a8.806,8.806,0,0,0-5.692,2.937A8.19,8.19,0,0,0,12.4,8.886a7.283,7.283,0,0,0,5.744-2.708Z",
    transform: "translate(3.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(43.401 16.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M13.976,16.326h-8.4l-2.017,5.94H0L7.957.29h3.7L19.61,22.266H15.991Zm-7.53-2.741H13.1L9.822,3.945H9.73Z",
    transform: "translate(0 0.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-2",
    "data-name": "\\u5F62\\u72B6",
    d: "M32.269,13.048c0,4.979-2.673,8.178-6.705,8.178a5.45,5.45,0,0,1-5.055-2.8h-.076v7.936h-3.3V5.036h3.192V7.7h.061A5.7,5.7,0,0,1,25.5,4.868C29.581,4.868,32.269,8.082,32.269,13.048Zm-3.39,0c0-3.244-1.681-5.377-4.246-5.377-2.52,0-4.215,2.178-4.215,5.377,0,3.228,1.7,5.39,4.215,5.39C27.2,18.438,28.879,16.321,28.879,13.048Z",
    transform: "translate(4.525 1.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-3",
    "data-name": "\\u5F62\\u72B6",
    d: "M46.259,13.048c0,4.979-2.672,8.178-6.705,8.178a5.45,5.45,0,0,1-5.055-2.8h-.076v7.936h-3.3V5.036h3.192V7.7h.061a5.7,5.7,0,0,1,5.116-2.833C43.571,4.868,46.259,8.082,46.259,13.048Zm-3.39,0c0-3.244-1.681-5.377-4.246-5.377-2.52,0-4.215,2.178-4.215,5.377,0,3.228,1.7,5.39,4.215,5.39,2.565,0,4.246-2.117,4.246-5.39Z",
    transform: "translate(8.219 1.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M53.048,16.22c.244,2.179,2.368,3.61,5.269,3.61,2.78,0,4.78-1.431,4.78-3.4,0-1.706-1.206-2.727-4.062-3.427l-2.856-.686c-4.047-.975-5.925-2.862-5.925-5.924,0-3.792,3.314-6.4,8.019-6.4,4.657,0,7.849,2.6,7.957,6.4H62.9c-.2-2.193-2.017-3.517-4.674-3.517S53.75,4.219,53.75,6.168c0,1.554,1.161,2.468,4,3.168l2.428.595c4.522,1.066,6.4,2.878,6.4,6.092,0,4.111-3.284,6.687-8.508,6.687-4.887,0-8.187-2.515-8.4-6.489Z",
    transform: "translate(13.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-2",
    "data-name": "\\u8DEF\\u5F84",
    d: "M69.859,2V5.792h3.055V8.4H69.859V17.23c0,1.372.612,2.012,1.955,2.012a10.348,10.348,0,0,0,1.085-.076v2.589a9.084,9.084,0,0,1-1.832.152c-3.253,0-4.522-1.218-4.522-4.326V8.4H64.209v-2.6h2.336V2Z",
    transform: "translate(16.957 0.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-4",
    "data-name": "\\u5F62\\u72B6",
    d: "M72.5,13.053c0-5.041,2.977-8.209,7.62-8.209,4.659,0,7.622,3.168,7.622,8.209s-2.948,8.209-7.622,8.209S72.5,18.108,72.5,13.053Zm11.882,0c0-3.458-1.589-5.5-4.262-5.5s-4.26,2.057-4.26,5.5c0,3.472,1.587,5.5,4.26,5.5s4.262-2.025,4.262-5.5Z",
    transform: "translate(19.145 1.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-3",
    "data-name": "\\u8DEF\\u5F84",
    d: "M86.7,5.035h3.146V7.763h.076a3.831,3.831,0,0,1,3.865-2.895,5.1,5.1,0,0,1,1.13.123V8.067a4.623,4.623,0,0,0-1.482-.2A3.318,3.318,0,0,0,90,11.554v9.5H86.7Z",
    transform: "translate(22.898 1.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-5",
    "data-name": "\\u5F62\\u72B6",
    d: "M108.262,16.358c-.444,2.909-3.284,4.9-6.918,4.9-4.674,0-7.575-3.123-7.575-8.133,0-5.026,2.917-8.285,7.437-8.285,4.445,0,7.241,3.045,7.241,7.9v1.127H97.1v.2a4.178,4.178,0,0,0,4.322,4.538,3.636,3.636,0,0,0,3.711-2.254ZM97.113,11.576h8.033a3.858,3.858,0,0,0-3.941-4.067,4.062,4.062,0,0,0-4.092,4.067Z",
    transform: "translate(24.763 1.279)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(45.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-6",
    "data-name": "\\u5F62\\u72B6",
    d: "M3.825.414A4.677,4.677,0,0,1,8.808,5.661c0,3.374-1.828,5.313-4.983,5.313H0V.414ZM1.645,9.48h2a3.324,3.324,0,0,0,3.492-3.8A3.333,3.333,0,0,0,3.641,1.906h-2Z",
    transform: "translate(0 0.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-7",
    "data-name": "\\u5F62\\u72B6",
    d: "M8.441,6.474a3.785,3.785,0,1,1,7.537,0,3.786,3.786,0,1,1-7.537,0Zm5.915,0c0-1.727-.778-2.738-2.144-2.738S10.07,4.747,10.07,6.474s.771,2.744,2.142,2.744,2.144-1.009,2.144-2.744Z",
    transform: "translate(2.224 0.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-4",
    "data-name": "\\u8DEF\\u5F84",
    d: "M24.181,10.43H22.545L20.893,4.561h-.125L19.124,10.43H17.5L15.3,2.461h1.6l1.432,6.081h.118l1.643-6.081h1.513l1.643,6.081h.125L24.8,2.461h1.577Z",
    transform: "translate(4.041 0.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-5",
    "data-name": "\\u8DEF\\u5F84",
    d: "M25.527,2.495h1.518V3.761h.118a2.393,2.393,0,0,1,2.385-1.42A2.595,2.595,0,0,1,32.314,5.3v5.159H30.737V5.7c0-1.281-.558-1.917-1.724-1.917A1.83,1.83,0,0,0,27.1,5.8v4.662H25.527Z",
    transform: "translate(6.741 0.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-6",
    "data-name": "\\u8DEF\\u5F84",
    d: "M32.884,0h1.577V11.08H32.884Z",
    transform: "translate(8.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-8",
    "data-name": "\\u5F62\\u72B6",
    d: "M35.87,6.474a3.785,3.785,0,1,1,7.538,0,3.786,3.786,0,1,1-7.538,0Zm5.915,0c0-1.727-.778-2.738-2.144-2.738S37.5,4.747,37.5,6.474s.771,2.744,2.142,2.744,2.144-1.009,2.144-2.744Z",
    transform: "translate(9.468 0.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-9",
    "data-name": "\\u5F62\\u72B6",
    d: "M43.143,8.208c0-1.434,1.071-2.261,2.972-2.379l2.165-.124V5.017c0-.842-.558-1.317-1.636-1.317-.88,0-1.49.322-1.665.886H43.451c.161-1.369,1.452-2.247,3.265-2.247,2,0,3.133.995,3.133,2.678v5.445H48.332V9.342h-.125a2.691,2.691,0,0,1-2.4,1.251,2.412,2.412,0,0,1-2.664-2.385Zm5.137-.681V6.861l-1.952.124c-1.1.073-1.6.447-1.6,1.149s.624,1.135,1.482,1.135A1.882,1.882,0,0,0,48.28,7.527Z",
    transform: "translate(11.394 0.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-10",
    "data-name": "\\u5F62\\u72B6",
    d: "M50.088,7.092c0-2.518,1.3-4.113,3.317-4.113a2.635,2.635,0,0,1,2.451,1.4h.118V0h1.577V11.08H56.04V9.821h-.125a2.775,2.775,0,0,1-2.51,1.39C51.373,11.211,50.088,9.616,50.088,7.092Zm1.629,0c0,1.69.8,2.707,2.135,2.707S56,8.767,56,7.1s-.83-2.707-2.151-2.707-2.135,1.024-2.135,2.7Z",
    transform: "translate(13.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-11",
    "data-name": "\\u5F62\\u72B6",
    d: "M61.158,6.474a3.785,3.785,0,1,1,7.537,0,3.786,3.786,0,1,1-7.537,0Zm5.915,0c0-1.727-.778-2.738-2.144-2.738s-2.142,1.01-2.142,2.738.771,2.744,2.142,2.744S67.073,8.208,67.073,6.474Z",
    transform: "translate(16.146 0.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-7",
    "data-name": "\\u8DEF\\u5F84",
    d: "M68.79,2.495h1.518V3.761h.118a2.393,2.393,0,0,1,2.385-1.42A2.595,2.595,0,0,1,75.577,5.3v5.159H74V5.7c0-1.281-.558-1.917-1.724-1.917A1.83,1.83,0,0,0,70.368,5.8v4.662H68.79Z",
    transform: "translate(18.167 0.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-8",
    "data-name": "\\u8DEF\\u5F84",
    d: "M81.8.891v2.02h1.731V4.236H81.8v4.1c0,.835.345,1.2,1.13,1.2a5.277,5.277,0,0,0,.6-.036v1.31a5.188,5.188,0,0,1-.858.08c-1.754,0-2.452-.615-2.452-2.152v-4.5H78.957V2.912h1.269V.891Z",
    transform: "translate(20.852 0.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-9",
    "data-name": "\\u8DEF\\u5F84",
    d: "M84.283,0h1.563V4.391h.125a2.46,2.46,0,0,1,2.437-1.428A2.628,2.628,0,0,1,91.16,5.935V11.08H89.581V6.323c0-1.273-.595-1.917-1.709-1.917a1.864,1.864,0,0,0-2.012,2.02V11.08H84.283Z",
    transform: "translate(22.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-12",
    "data-name": "\\u5F62\\u72B6",
    d: "M98.5,8.31a3.244,3.244,0,0,1-3.463,2.305A3.623,3.623,0,0,1,91.346,6.5,3.679,3.679,0,0,1,95.03,2.339c2.224,0,3.565,1.515,3.565,4.017v.549H92.952v.088A2.109,2.109,0,0,0,95.08,9.276a1.917,1.917,0,0,0,1.9-.966ZM92.952,5.742h4.036a1.925,1.925,0,0,0-1.967-2.064,2.041,2.041,0,0,0-2.069,2.064Z",
    transform: "translate(24.114 0.618)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLinkApple);
export default __webpack_public_path__ + "static/media/app_link_apple.06e2f3d0d03e4b53fa131115c6b51090.svg";
export { ForwardRef as ReactComponent };